import { FetchParams } from '../models';
import { serializeFilters } from './serializeFilters';

export function buildQueryParams(params: FetchParams): URLSearchParams {
  const query = new URLSearchParams();

  query.set('offset', params.offset.toString());
  query.set('limit', params.limit.toString());
  query.set('order', params.sortModel.toString());

  // Serialize sort model
  const orders: string[] = [];
  params.sortModel.forEach(sort => {
    orders.push(`${sort.field}.${sort.order}`);
  });
  if (orders.length > 0) {
    query.set('order', orders.join(','));
  }
  // Serialize filters object
  const filters = serializeFilters(params.filters);
  if (filters.length > 0) {
    const filterString = filters.join(',');
    query.set(`filter`, filterString);
  }
  return query;
}
